module.exports = __webpack_public_path__ + "img/wordcloud-luigi-cutolo.499d67d9.png";